module.exports = __webpack_public_path__ + "static/media/depressao.bb43aeb8.png";